import { lazy } from 'react'

export const newsLoadables = {
	LoadableOneNews: lazy(() => import('../containers/News/OneNews')),
	LoadableAddNews: lazy(() => import('../containers/News/ManageNews/createNews'))
}
